export default "__VITE_ASSET__f_JLTZHWaH18hR2YNrhwKg__"